const normalizedId = (value) => (
  value == null ? null : String(value)
);

const SPORTSNEW_SCOPES = new Set(['all', 'domestic', 'overseas', 'live', 'esports']);
const SPORTSNEW_SCOPE_ALIASES = {
  international: 'overseas',
  global: 'overseas',
  foreign: 'overseas',
  local: 'domestic',
  korea: 'domestic',
  kr: 'domestic',
  inplay: 'live',
  'e-sports': 'esports',
  special: 'esports',
};

export const sportsnewActiveFixtureMode = (mode) => {
  const normalized = String(mode || '').trim().toLowerCase();
  // The existing detail subscription intentionally maps the list-only "all"
  // mode to prematch. Every connect/reconnect/guard path must use the same room.
  return normalized === 'live' ? 'live' : 'prematch';
};

const normalizedScope = (scope) => {
  const raw = String(scope || '').trim().toLowerCase();
  const normalized = (SPORTSNEW_SCOPE_ALIASES[raw] ?? raw) || 'all';
  return SPORTSNEW_SCOPES.has(normalized) ? normalized : 'all';
};

export const sportsnewFixtureRoomForIdentity = ({ fixtureId, mode, scope } = {}) => {
  const id = normalizedId(fixtureId);
  if (id == null) return null;
  const normalizedMode = sportsnewActiveFixtureMode(mode);
  const fixtureScope = normalizedScope(scope);
  const scopeSegment = fixtureScope === 'all' ? '' : `:${fixtureScope}`;
  return `sportsnew:fixture:${normalizedMode}${scopeSegment}:${id}`;
};

export const sportsnewFixturePatchTargetId = (patch) => normalizedId(
  patch?.fixtureId
  ?? patch?.fixture_id
  ?? patch?.id
  ?? patch?.fixture?.fixtureId
  ?? patch?.fixture?.fixture_id
  ?? patch?.fixture?.id
);

export const isSportsnewFixturePatchForActiveDetail = (patch, activeIdentity) => {
  const activeId = normalizedId(activeIdentity?.fixtureId);
  if (activeId == null) return false;

  const patchId = sportsnewFixturePatchTargetId(patch);
  if (patchId !== activeId) return false;

  const expectedRoom = sportsnewFixtureRoomForIdentity(activeIdentity);
  if (!expectedRoom || patch?.room !== expectedRoom) return false;

  const patchMode = patch?.mode == null ? null : sportsnewActiveFixtureMode(patch.mode);
  return patchMode == null || patchMode === sportsnewActiveFixtureMode(activeIdentity?.mode);
};

export const sportsnewFixtureMetadataDelta = (patch) => (
  patch?.fixture && typeof patch.fixture === 'object' && !Array.isArray(patch.fixture)
    ? patch.fixture
    : patch
);
